import React from 'react';
import s from './CirclePulseAnimation.scss';
const hexToRgb = (hex) => {
    if (hex.startsWith('#')) {
        hex = hex.slice(1);
    }
    const red = parseInt(hex.substring(0, 2), 16);
    const green = parseInt(hex.substring(2, 4), 16);
    const blue = parseInt(hex.substring(4, 6), 16);
    return `${red}, ${green}, ${blue}`;
};
export const CirclePulseAnimation = ({ color, }) => {
    const style = {
        '--circle-color': hexToRgb(color),
    };
    return (React.createElement("div", { className: s.circlePulseAnimation, style: style, "data-hook": "pulse-circle" }));
};
//# sourceMappingURL=CirclePulseAnimation.js.map